import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.starts-with";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { TreeMixin, itemTypeLoadMore, itemTypeDefault } from './mixin';
import { mapState } from 'vuex';
export default {
  name: 'CoreDtwinTreeDefault',
  mixins: [TreeMixin],
  props: {
    searchEnabled: {
      type: Boolean,
      required: false,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      loadedInitialDtwins: false
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])),
  watch: {
    twinTreeItems: function twinTreeItems() {
      if (!this.loadedInitialDtwins) {
        if (this.twinTreeItems.length > 0) {
          this.loadedInitialDtwins = true;
          this.$emit('initialDtwins', this.twinTreeItems);
        }
      }
    }
  },
  created: function created() {
    this.itemTypeLoadMore = itemTypeLoadMore;
  },
  mounted: function mounted() {
    this.initTree();
  },
  methods: {
    initTree: function initTree() {
      this.twinTreeItems = [];
      this.twinItemMapping = {};
      this.active = null;
      this.twinItemMapping[this.parentId] = {}; // an active node is specified, so make sure to load the tree-structure to accomodate this node
      // might not be on root-level, so there is special handling required to have it displayed right away

      if (this.activeDtwinId) {
        this.fetchPartialTree(this.activeDtwinId);
      } else {
        this.fetchChildren({
          id: this.parentId
        }, true);
      }
    },
    fetchChildren: function fetchChildren(item) {
      var initially = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this.fetchChildrenDefault(item.id, 0, initially);
    },
    processTreeItems: function processTreeItems(items) {
      this.processTreeItemsDefault(items);
    },
    itemType: function itemType(item) {
      if (typeof item.id === 'string') {
        if (item.id.startsWith(itemTypeLoadMore)) {
          return itemTypeLoadMore;
        }
      }

      return itemTypeDefault;
    },
    getTwinTreeIcon: function getTwinTreeIcon(dtwin) {
      // special case for the "Load More" tree item
      if (this.itemType(dtwin) === itemTypeLoadMore) {
        return this.getTwinTreeIconDefault(dtwin);
      }

      return this.getTwinTreeIconDefault(dtwin);
    }
  }
};